import _regeneratorRuntime from "__________________________________________/i18n_fe/i18n_ecommerce_alliance/node_modules/.pnpm/@babel+runtime@7.27.0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "__________________________________________/i18n_fe/i18n_ecommerce_alliance/node_modules/.pnpm/@babel+runtime@7.27.0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectWithoutProperties from "__________________________________________/i18n_fe/i18n_ecommerce_alliance/node_modules/.pnpm/@babel+runtime@7.27.0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "__________________________________________/i18n_fe/i18n_ecommerce_alliance/node_modules/.pnpm/@babel+runtime@7.27.0/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "__________________________________________/i18n_fe/i18n_ecommerce_alliance/node_modules/.pnpm/@babel+runtime@7.27.0/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _merge from "lodash-es/merge";
var _excluded = ["dispatch"];
import { createContext, useContext, useReducer } from 'react';
import { Logger } from '@ecom-alliance/libs';
import { affiliateBffApiClient } from '@/api/affiliate/serv/bff/oec_affiliate_bff_api';
import { AppRuntimeContext } from '@/App';
import { CREATORS_MAX_NUMBER, PRODUCTS_MAX_NUMBER } from '@/pages/find-creators/constants';
import useIMQuota from './use-im-quota';
import { jsx as _jsx } from "react/jsx-runtime";
var ActionEnum = /*#__PURE__*/function (ActionEnum) {
  ActionEnum["INITIALIZE_STATE"] = "initialize_state";
  ActionEnum["UPDATE_STATE"] = "update_state";
  return ActionEnum;
}(ActionEnum || {});
var defaultValue = {
  invitationContactFields: [{
    field: 7,
    type: 'invitation_email',
    isRequired: true
  }, {
    field: 6,
    type: 'invitation_whatsapp'
  }],
  targetInvitationMaxCreatorsNumber: CREATORS_MAX_NUMBER,
  targetInvitationMaxProductsNumber: PRODUCTS_MAX_NUMBER,
  ruleModal: {
    props: null
  },
  isInAddCreatorToCrmABtest: false,
  invitationMessageTempleInfo: {
    display: '',
    template: ''
  }
};
var ConnectionContext = /*#__PURE__*/createContext({});
var reducer = function reducer(state, action) {
  switch (action.type) {
    case ActionEnum.INITIALIZE_STATE:
      return _objectSpread({}, action.payload);
    case ActionEnum.UPDATE_STATE:
      return _objectSpread(_objectSpread({}, state), action.payload);
    default:
      return _objectSpread({}, state);
  }
};
var ConnectionStateProvider = function ConnectionStateProvider(props) {
  var children = props.children;
  var _useReducer = useReducer(reducer, defaultValue),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  var _useIMQuota = useIMQuota(),
    imQuota = _useIMQuota.imQuota,
    imEntrance = _useIMQuota.imEntrance,
    imEntranceLoading = _useIMQuota.imEntranceLoading,
    setCreatorIds = _useIMQuota.setCreatorIds,
    ruleModal = _useIMQuota.ruleModal,
    refreshIMEntry = _useIMQuota.refreshIMEntry,
    refreshQuota = _useIMQuota.refreshQuota;
  var hasCreatorConnectPhase1Permission = state.hasCreatorConnectPhase1Permission;
  return /*#__PURE__*/_jsx(ConnectionContext.Provider, {
    value: _objectSpread(_objectSpread({}, state), {}, {
      dispatch: dispatch,
      // TODO: rename the param and remove loading state after the new version full launched globally
      inFilterExperimentGroup: hasCreatorConnectPhase1Permission,
      inFilterExperimentGroupLoading: false,
      imQuota: imQuota,
      imEntrance: imEntrance,
      imEntranceLoading: imEntranceLoading,
      setCreatorIds: setCreatorIds,
      ruleModal: ruleModal,
      refreshQuota: refreshQuota,
      refreshIMEntry: refreshIMEntry
    }),
    children: children
  });
};
var useConnectionState = function useConnectionState() {
  var _useContext = useContext(ConnectionContext),
    dispatch = _useContext.dispatch,
    state = _objectWithoutProperties(_useContext, _excluded);
  var _useContext2 = useContext(AppRuntimeContext),
    account = _useContext2.account;
  return _objectSpread(_objectSpread({}, state), {}, {
    dispatch: {
      initializeState: function initializeState(payload) {
        dispatch({
          type: ActionEnum.INITIALIZE_STATE,
          payload: payload
        });
      },
      updateState: function updateState(payload) {
        dispatch({
          type: ActionEnum.UPDATE_STATE,
          payload: payload
        });
      },
      fetchConnectionTccConfig: function fetchConnectionTccConfig(params) {
        return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var _params, configKeys, platformConfig, config, _data$affiliate, _account$region, _yield$affiliateBffAp, data, submoduleTccConfig;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (params === void 0) {
                  params = {
                    configKeys: ['affiliate_connection_submodule_local_config'],
                    platformConfig: {}
                  };
                }
                _params = params, configKeys = _params.configKeys, platformConfig = _params.platformConfig; // define default value
                config = {};
                _context.prev = 3;
                _context.next = 6;
                return affiliateBffApiClient.GetConfig({
                  keys: configKeys.join(',')
                });
              case 6:
                _yield$affiliateBffAp = _context.sent;
                data = _yield$affiliateBffAp.data;
                submoduleTccConfig = (_data$affiliate = data === null || data === void 0 ? void 0 : data.affiliate) !== null && _data$affiliate !== void 0 ? _data$affiliate : {};
                config = _objectSpread(_objectSpread({}, submoduleTccConfig[configKeys[0]].default), submoduleTccConfig[configKeys[0]][(_account$region = account.region) !== null && _account$region !== void 0 ? _account$region : 'default']);
                _context.next = 15;
                break;
              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](3);
                Logger.error("[Error]: fetchConnectionTccConfig failed.", 'some errors has occurred in fetchConnectionTccConfig', _context.t0);
              case 15:
                dispatch({
                  type: ActionEnum.UPDATE_STATE,
                  payload: _merge(_objectSpread({}, platformConfig), config)
                });
              case 16:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[3, 12]]);
        }))();
      }
    }
  });
};
export default ConnectionStateProvider;
export { useConnectionState };